module.exports = (__parcel__import__("kbIBq")).then(() => parcelRequire('ieIpp'));